import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ProgressBar } from 'react-bootstrap';
import Pusher from '../pusher';
import ProgressBar2 from '../progress-bar';
import NumberDisplay from '../number-display';
import Counter from '../counter';
import styles from './styles.css';
import AnimatedText from '../animated-text';

// Import Selectors
import {
  getUser, getIsUsingOrganizationSwitch, getUserCurrentOrganization,
  getCanSetupOrganization,
} from '../../modules/Auth/AuthReducer';


class SyncProgress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      syncPercentage: 0,
      syncMasterPercentage: 0,
      totalResources: 0,
      syncResource: null,
    };
    this.handleSyncingStart = this.handleSyncingStart.bind(this);
    this.handleSyncingSuccess = this.handleSyncingSuccess.bind(this);
    this.handleSyncingProgress = this.handleSyncingProgress.bind(this);
  }


  handleSyncingStart(org, totalResources) {
    console.log('start')
    this.setState({
      syncResource: null, syncMasterPercentage: 0, syncPercentage: 0, totalResources,
    });
  }

  handleSyncingSuccess() {
    console.log('success')
    this.setState({ syncResource: null, syncMasterPercentage: 100, syncPercentage: 100 });
  }

  handleSyncingProgress(org, syncResource, totalResources, syncMasterPercentage, syncPercentage) {
    console.clear();
    console.log('handleSyncingProgress');
    this.setState({
      syncResource, syncPercentage, totalResources, syncMasterPercentage,
    });
  }

  renderSyncProcess() {
    const {
      syncResource, syncMasterPercentage, syncPercentage, totalResources,
    } = this.state;
    const { mini } = this.props;
    /*
    const syncResource = 'Accounts';
    const syncMasterPercentage = 80;
    const syncPercentage = 50;
    const totalResources = 10;
    */

    const segments = totalResources ? 1 / totalResources : 1;


    let count = null;

    let bar = (<ProgressBar2 />);
    if (syncResource !== null) {
      count = (<Counter value={syncPercentage}><NumberDisplay suffix="%" precision={1} value={syncPercentage} /></Counter>);
      bar = (
        <ProgressBar>
          <ProgressBar active bsStyle="success" striped now={syncMasterPercentage} />
          <ProgressBar active striped bsStyle="success" now={segments * syncPercentage} />
        </ProgressBar>
      );
    }
    if (mini) {
      return (
        <div>
          <div><strong>{(syncResource || 'Resources')}</strong>: {count}</div>
          {bar}
        </div>
      );
    }
    return (
      <div key="syncProgress" className="container">
        <div style={{ height: 100 }} />
        <div>
          <div className={styles.syncText}>Syncing:</div>
          <table width="100%">
            <tbody>
              <tr>
                <td style={{ verticalAlign: 'top' }}>
                  <AnimatedText text={(syncResource || 'Resources')} />
                </td>
                <td style={{ verticalAlign: 'top' }}>
                  <div className="text-right">
                    <div className={styles.percentText}>{count}</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p /><p />
        {bar}
      </div>
    );
  }

  renderSockets() {
    const { organization } = this.props;
    if (!organization) {
      return null;
    }
    const orgId = organization._id;
    return (
      <div>
        <Pusher key={`${orgId}-syncingOrganization`} event="syncingOrganization" handler={this.handleSyncingStart} />
        <Pusher key={`${orgId}-syncingOrganizationSuccess`} event="syncingOrganizationSuccess" handler={this.handleSyncingSuccess} />
        <Pusher key={`${orgId}-syncingOrganizationProgress`} event="syncingOrganizationProgress" handler={this.handleSyncingProgress} />
      </div>
    );
  }
  

  render() {
    const { organization } = this.props;
    if (!organization) {
      return null;
    }
    const orgId = organization._id;
    return (
      <div key={orgId}>
        {this.renderSyncProcess()}
        {this.renderSockets()}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
    organization: getUserCurrentOrganization(state),
    canSetup: getCanSetupOrganization(state),
    isUsingOrganizationSwitch: getIsUsingOrganizationSwitch(state),
  };
}

SyncProgress.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.shape({
    user_id: PropTypes.string,
  }).isRequired,
  canSetup: PropTypes.bool.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string,
    syncing: PropTypes.bool,
    is_demo: PropTypes.bool,
    last_synced_date: PropTypes.string,
  }),
  isUsingOrganizationSwitch: PropTypes.bool,
  mini: PropTypes.bool,
};

SyncProgress.defaultProps = {
};

SyncProgress.contextTypes = {
};

export default connect(mapStateToProps)(SyncProgress);